import { createMiddleware } from '@shared/redux';
import { types as clusterActionTypes } from '@domain/dashboard/cluster/cluster.state';
import { trackOnRudderStack } from '@domain/analytics';
import { getSharedData } from './utils';

const activatedSuffix = (activated: boolean, succeeded: boolean) => {
    if (succeeded) {
        return activated ? 'activated' : 'deactivated';
    }

    return activated ? 'activation_failed' : 'deactivation_failed';
};

const checkOnStatusBudgetManager = (newCluster, oldCluster, succeeded, params): void => {
    if (newCluster.status_budget_manager !== oldCluster.status_budget_manager) {
        trackOnRudderStack(
            `bbm_budget_manager_${activatedSuffix(
                newCluster.status_budget_manager,
                succeeded,
            )}`,
            params,
        );
    }
};

const checkOnStatusTargetManager = (newCluster, oldCluster, succeeded, params): void => {
    if (newCluster.status_bid_manager !== oldCluster.status_bid_manager) {
        trackOnRudderStack(
            `bbm_bid_manager_${activatedSuffix(
                newCluster.status_bid_manager,
                succeeded,
            )}`,
            params,
        );
    }
};

const checkOnChangeBudget = (newCluster, oldCluster, succeeded, params, action): void => {
    if (newCluster.monthly_budget !== oldCluster.monthly_budget) {
        const changeType = action.requestAction.payload.changeType || 'conservative';
        trackOnRudderStack(
            `bbm_${changeType}_monthly_budget${succeeded ? '_changed' : '_change_failed'}`,
            params,
        );
    }
};

const requestEvent = (state, action, succeeded) => {
    const shared = getSharedData(state);

    const clusters = state?.dashboard?.clusters?.clusterCollection?.data || [];
    const newCluster = action.requestAction.config.data;
    const oldCluster = clusters.find(it => it.id === newCluster?.id);

    const params = {
        ...shared,
        clusterId: newCluster.id,
        statusBudgetManager: newCluster.status_budget_manager,
        statusBidManager: newCluster.status_bid_manager,
        oldMonthlyBudget: oldCluster.monthly_budget,
        newMonthlyBudget: newCluster.monthly_budget,
    };

    checkOnStatusBudgetManager(newCluster, oldCluster, succeeded, params);
    checkOnStatusTargetManager(newCluster, oldCluster, succeeded, params);
    checkOnChangeBudget(newCluster, oldCluster, succeeded, params, action);
};

export const clusterMiddleware = createMiddleware({
    [clusterActionTypes.EDIT_CLUSTER_REQUEST_SUCCEEDED]: (state, action) => {
        requestEvent(state, action, true);
    },
    [clusterActionTypes.EDIT_CLUSTER_REQUEST_FAILED]: (state, action) => {
        requestEvent(state, action, false);
    },
}, { beforeChanges: true });
